export default function (app) {
	app.factory('UserService', ['BaseService', function (BaseService) {
		var factory = {};
		factory.modifyUserBasicData = function (user) {
			const phoneNumber = user.phone.replace(/[ ]/g, '');
			const params = {
				body: {
					profileRequest: {
						LoginName: user.name,
						FullName: user.fullname,
						PhoneNumber: phoneNumber,
						EmailAddress: user.email,
					},
					fileUploadData: user.logo
				}
			};

			return BaseService.createPromise('modifyUserProfileData', params);
		};

		factory.modifyUserPhoneNumber = function (user) {
			const phoneNumber = user.phone.replace(/[ ]/g, '');
			const params = {
				body: {
					newPhoneNumber: phoneNumber
				}
			};

			return BaseService.createPromise('modifyUserPhoneNumber', params);
		};

		factory.getCompanyLogos = function () {
			return BaseService.createPromise('getCompanyLogo');
		}

		factory.checkSMS = function (smsCode) {
			var params = {
				headers: {
					'X-smsCode': smsCode
				}
			};
			return BaseService.createPromise('checkSMS', params);
		};

		factory.checkPasswordSMS = function (smsCode) {
			var params = {
				headers: {
					'X-smsCode': smsCode
				}
			};
			return BaseService.createPromise('checkPasswordSMS', params);
		};

		factory.checkForgotPasswordSMS = function (smsCode) {
			var params = {
				headers: {
					'X-smsCode': smsCode
				}
			};
			return BaseService.createPromise('checkForgotPasswordSMS', params);
		};

		factory.modifyPassword = function (user) {
			var params = {
				body: {
					LoginName: user.name,
					CurrentPassword: btoa(user.oldPassword),
					NewPassword: btoa(user.newPassword)
				}
			};
			return BaseService.createPromise('changePassword', params);
		};

		factory.validatePassword = function (user) {
			var params = {
				body: {
					LoginName: user.name,
					CurrentPassword: btoa(user.oldPassword)
				}
			};
			return BaseService.createPromise('validatePassword', params);
		};

		factory.checkIsEmailTaken = function (email) {
			var params = {
				urlParameters: {
					UserEmail: email
				}
			}

			return BaseService.createPromise('getEmailAlreadyTaken', params);
		};

		return factory;
	}]);
};
